import httpStore from "@/api/httpStore.js";

export const getDepartments = () => {
  return httpStore
    .get("departments")
    .then(data => {
      return data.data.map(department => ({
        code: department.codigo,
        name: department.nombre,
        full: department
      }));
    })
    .catch(error => {
      console.error("Error getting departments", error);
      return [];
    });
};

/**
 * Listado completo para la pantalla de gestion de departamentos.
 * El endpoint nunca devuelve serverPassword: solo hasServerPassword.
 */
export const getDepartmentsForManagement = () => {
  return httpStore.get("departments/manage").then(res => res.data.data);
};

/**
 * Actualiza un departamento. El payload va en snake_case porque la API de
 * CodeIgniter espera los nombres de columna tal cual.
 * `server_password` solo debe enviarse cuando el usuario escribe una nueva;
 * `clear_server_password: true` borra la guardada.
 */
export const updateDepartment = (id, payload) => {
  return httpStore
    .put(`departments/manage/${id}`, payload)
    .then(res => res.data.data);
};

/**
 * Crea un departamento. cia_id, departamento_id, codigo y nombre son
 * obligatorios; departamento_id debe ser unico.
 */
export const createDepartment = payload => {
  return httpStore
    .post("departments/manage", payload)
    .then(res => res.data.data);
};
